// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3UctT","textarea":"styles_textarea__1u_id"};